module.exports = __webpack_public_path__ + "nm-icons_0bfaa67614d37c25ad6f6a8877152021.ttf?f4f54d33de65240bb41cf8fcce37f629";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_0bfaa67614d37c25ad6f6a8877152021.ttf
// module id = 1394
// module chunks = 35